import {Component, Input, OnInit} from '@angular/core';
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import { SucursalLocationService } from './services/sucursal-location.service';
import { Apollo} from "apollo-angular";
import { sucursalesActivas } from '../../graphql/graphql.queris';


@Component({
  selector: 'app-sucursal-location',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    AsyncPipe
  ],
  templateUrl: './sucursal-location.component.html',
  styleUrl: './sucursal-location.component.css'
})
export class SucursalLocationComponent implements OnInit {

  data : any[] = [];
  getSucursalesActivas: any[]=[];
  loading = true;
  error: any;


  constructor(
    private sucursalLocationService: SucursalLocationService,
    private apollo: Apollo
  ) {
  }

  ngOnInit(): void {
    this.apollo
      .watchQuery({
        query: sucursalesActivas
      })
      .valueChanges.subscribe((result: any)=>{
        this.data = result?.data?.getSucursalesActivas;
        this.loading = result.loading;
        this.error = result.error;
    })
  }

  convertirPrimeraLetraMayuscula(texto: string): string {
    return texto.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

}
